(function () {
  'use strict';

  var KEY = 'trautis_wishlist_v1';
  var CARD_SECTION_ID = 'wishlist-card-trautis';

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) { return []; }
  }

  function write(arr) {
    try { window.localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('trautis:wishlist-change', { detail: { count: arr.length } }));
  }

  function isInList(handle, variantId) {
    return read().some(function (i) { return i.productHandle === handle && i.variantId === variantId; });
  }

  function add(item) {
    var arr = read();
    if (isInList(item.productHandle, item.variantId)) return;
    arr.push(Object.assign({ addedAt: new Date().toISOString() }, item));
    write(arr);
  }

  function remove(handle, variantId) {
    var arr = read().filter(function (i) { return !(i.productHandle === handle && i.variantId === variantId); });
    write(arr);
  }

  function removeAllForHandle(handle) {
    var arr = read().filter(function (i) { return i.productHandle !== handle; });
    write(arr);
  }

  function toggle(item) {
    if (isInList(item.productHandle, item.variantId)) {
      remove(item.productHandle, item.variantId);
      return false;
    }
    add(item);
    return true;
  }

  function count() { return read().length; }

  function handlesNewestFirst(items) {
    var out = [], seen = {};
    for (var i = items.length - 1; i >= 0; i--) {
      var h = items[i] && items[i].productHandle;
      if (!h || seen[h]) continue;
      seen[h] = true;
      out.push(h);
    }
    return out;
  }

  function cardEndpointRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  // Liquid can't read URL query params (the request object has no query_string),
  // so a single ?handles=… endpoint is impossible. Instead fetch each card via
  // the Section Rendering API in the product's OWN context → full-fidelity card
  // (the same snippet as the collection grid), one request per handle.
  function buildCardFetchUrl(handle) {
    return cardEndpointRoot() + 'products/' + encodeURIComponent(handle) + '?section_id=' + CARD_SECTION_ID;
  }

  function handleNoLongerSaved(handle) {
    return !read().some(function (i) { return i.productHandle === handle; });
  }

  function onChange(handler) {
    var wrapped = function (e) { handler(e.detail); };
    document.addEventListener('trautis:wishlist-change', wrapped);
    return function () { document.removeEventListener('trautis:wishlist-change', wrapped); };
  }

  window.TrautisWishlist = {
    get: read, isInList: isInList, add: add, remove: remove,
    removeAllForHandle: removeAllForHandle,
    toggle: toggle, count: count, onChange: onChange,
    handlesNewestFirst: handlesNewestFirst,
    buildCardFetchUrl: buildCardFetchUrl,
    handleNoLongerSaved: handleNoLongerSaved
  };

  // ---- PDP heart binding --------------------------------------------------
  function bindHeart() {
    var heart = document.querySelector('[data-wishlist-toggle]');
    if (!heart) return;
    var sectionRoot = heart.closest('[data-product-section]');
    if (!sectionRoot) return;

    function currentSnapshot() {
      var script = sectionRoot.querySelector('script[data-product-json]');
      var product;
      try { product = JSON.parse(script.textContent); } catch (e) { return null; }
      var variantId = parseInt(sectionRoot.querySelector('input[name="id"]').value, 10);
      var variant = product.variants.find(function (v) { return v.id === variantId; });
      if (!variant) return null;
      var imgEl = document.querySelector('.t-media__slide.is-active .t-media__img');
      return {
        productHandle: product.handle,
        variantId: variant.id,
        snapshot: {
          title: product.title,
          vendor: '',
          price: variant.price,
          currency: 'EUR',
          imageUrl: imgEl ? imgEl.src : '',
          productUrl: '/products/' + product.handle + '?variant=' + variant.id
        }
      };
    }

    function syncAriaPressed() {
      var snap = currentSnapshot();
      if (!snap) return;
      heart.setAttribute('aria-pressed', isInList(snap.productHandle, snap.variantId) ? 'true' : 'false');
    }

    heart.addEventListener('click', function () {
      var snap = currentSnapshot();
      if (!snap) return;
      var nowIn = toggle(snap);
      heart.setAttribute('aria-pressed', nowIn ? 'true' : 'false');
      toast(nowIn ? 'Zum Wunschzettel hinzugefügt.' : 'Vom Wunschzettel entfernt.');
    });

    syncAriaPressed();
    document.addEventListener('trautis:variant-change', syncAriaPressed);
  }

  function toast(text) {
    var t = document.createElement('div');
    t.className = 't-toast';
    t.setAttribute('role', 'status');
    t.textContent = text;
    document.body.appendChild(t);
    setTimeout(function () { t.classList.add('is-out'); }, 1800);
    setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 2400);
  }

  // ---- Wunschzettel page rendering ----------------------------------------
  function bindWishlistHearts(listEl) {
    if (!listEl || !listEl.querySelectorAll) return;
    var hearts = listEl.querySelectorAll('.t-product-card__wish');
    for (var i = 0; i < hearts.length; i++) {
      var heart = hearts[i];
      if (heart.hasAttribute('data-trautis-bound-wish')) continue;
      heart.setAttribute('data-trautis-bound-wish', ''); // also blocks the shared (handle,variant) binder
      heart.removeAttribute('disabled');
      heart.setAttribute('aria-pressed', 'true');        // every shown card IS in the list
      (function (h) {
        h.addEventListener('click', function (e) {
          if (e && e.preventDefault) e.preventDefault();
          var handle = h.getAttribute('data-product-handle');
          if (handle) removeAllForHandle(handle);         // fires trautis:wishlist-change → onChange removes the node
        });
      })(heart);
    }
  }

  function setCount(root, n) {
    // Nur die Chrome-Leisten-Zählung; die frühere Hero-Meta-Zählung (unter dem
    // Titel im Masthead) war redundant und wurde entfernt.
    var label = root.querySelector('[data-wishlist-count-label]');
    if (label) label.textContent = n + (n === 1 ? ' gemerktes Teil' : ' gemerkte Teile');
  }

  function buildSkeletons(n) {
    var frag = [];
    for (var i = 0; i < n; i++) {
      var s = document.createElement('div');
      s.className = 't-wish-skeleton';
      s.setAttribute('aria-hidden', 'true');
      frag.push(s);
    }
    return frag;
  }

  function showEmpty(root) {
    var listEl = root.querySelector('[data-wishlist-list]');
    var emptyEl = root.querySelector('[data-wishlist-empty]');
    if (listEl) { listEl.replaceChildren(); listEl.setAttribute('hidden', ''); }
    if (emptyEl) emptyEl.removeAttribute('hidden');
    setCount(root, 0);
  }

  // Fetch ONE product card via the Section Rendering API. Resolves to
  // { node, error }: node = the <article data-recently-card> (or null), error =
  // true only on a network failure (a 404 = product genuinely gone → drop quietly).
  function fetchCardNode(handle) {
    return fetch(buildCardFetchUrl(handle))
      .then(function (r) {
        if (!r.ok) return { node: null, error: false }; // 404/weg → still droppen, nicht alarmieren
        return r.text().then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return { node: doc.querySelector('[data-recently-card]'), error: false };
        });
      })
      .catch(function () { return { node: null, error: true }; }); // Netzwerkfehler
  }

  function renderWunschzettel(root) {
    var listEl = root.querySelector('[data-wishlist-list]');
    var emptyEl = root.querySelector('[data-wishlist-empty]');
    if (!listEl) return Promise.resolve();

    var handles = handlesNewestFirst(read());
    if (!handles.length) { showEmpty(root); return Promise.resolve(); }

    if (emptyEl) emptyEl.setAttribute('hidden', '');
    listEl.removeAttribute('hidden');
    listEl.replaceChildren.apply(listEl, buildSkeletons(handles.length));
    setCount(root, handles.length);

    // Promise.all preserves handle order (newest first) regardless of which
    // request settles first → cards stay in the intended order.
    return Promise.all(handles.map(fetchCardNode)).then(function (results) {
      var cards = results.map(function (r) { return r.node; }).filter(Boolean);
      if (!cards.length) {
        if (results.some(function (r) { return r.error; })) {
          // Nicht alarmierend: Skeletons stehen lassen + dezenter Hinweis.
          listEl.setAttribute('data-wishlist-error', '');
        } else {
          showEmpty(root); // wirklich alle weg (404) → Leer-Zustand
        }
        return;
      }
      listEl.replaceChildren.apply(listEl, cards);
      setCount(root, cards.length); // gelöschte Produkte fallen weg → echte Zahl
      bindWishlistHearts(listEl);
    });
  }

  function removeCardByHandle(root, handle) {
    var listEl = root.querySelector('[data-wishlist-list]');
    if (!listEl) return;
    var node = listEl.querySelector('[data-recently-card][data-product-handle="' + handle + '"]');
    if (node && node.parentNode) node.parentNode.removeChild(node);
    var remaining = listEl.querySelectorAll('[data-recently-card]').length;
    if (!remaining) { showEmpty(root); } else { setCount(root, remaining); }
  }

  function bindWunschzettel() {
    var root = document.querySelector('[data-wishlist-page]');
    if (!root) return;
    renderWunschzettel(root);
    onChange(function () {
      // Nur Karten entfernen, deren Handle nicht mehr gespeichert ist (kein Re-Fetch).
      var listEl = root.querySelector('[data-wishlist-list]');
      if (!listEl) return;
      var nodes = Array.prototype.slice.call(listEl.querySelectorAll('[data-recently-card]'));
      nodes.forEach(function (n) {
        var h = n.getAttribute('data-product-handle');
        if (h && handleNoLongerSaved(h)) removeCardByHandle(root, h);
      });
    });
  }

  function onWishlistAddClick(evt) {
    var t = evt.target;
    var btn = t && t.closest ? t.closest('button.t-product-card__atc[data-variant-id]') : null;
    if (!btn) return;
    if (evt.preventDefault) evt.preventDefault();
    if (window.TrautisCartUpsellAdd && window.TrautisCartUpsellAdd.quickAdd) {
      window.TrautisCartUpsellAdd.quickAdd(btn);
    }
  }

  function init() {
    bindHeart();
    bindWunschzettel();
    if (document.querySelector('[data-wishlist-page]') && document.addEventListener) {
      document.addEventListener('click', onWishlistAddClick);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Node.js export for contract tests (Phase 3a T1+T2)
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      get: read, isInList: isInList, add: add, remove: remove,
      removeAllForHandle: removeAllForHandle,
      toggle: toggle, count: count, onChange: onChange,
      handlesNewestFirst: handlesNewestFirst,
      buildCardFetchUrl: buildCardFetchUrl,
      handleNoLongerSaved: handleNoLongerSaved,
      renderWunschzettel: renderWunschzettel,
      removeCardByHandle: removeCardByHandle,
      bindWishlistHearts: bindWishlistHearts,
      onWishlistAddClick: onWishlistAddClick
    };
  }
})();
